import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toDate, toMoney, toPhone } from '@/modules/core/utils/formats';

export const getPaginatedVisionOneData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`dashboard?${new URLSearchParams(params).toString()}`);
  return response.data;
};

export const getAllVisionOneData = async(options) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`dashboard?${new URLSearchParams(params).toString()}`);
  return response.data.dados.map((data) => [
    `"${data.codigo}"`,
    `"${toDate(data.dataHoraServico)}"`,
    `"${data.status}"`,
    `"${data.tipoOs}"`,
    `"${data.nomeCliente}"`,
    `"${toPhone(data.foneCliente)}"`,
    `"${toDate(data.dataHoraEncerramento)}"`,
    `"${toMoney(data.valorServicos)}"`,
    `"${toMoney(data.valorProdutos)}"`,
    `"${toMoney(data.valorTotal)}"`,
    `"${toMoney(data.valorTotalDesconto)}"`,
    `"${toMoney(data.valorPago)}"`,
    `"${data.usuarioNome}"`,
  ]);
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
  dataCriacaoInicial: options.creationInitialDate || '',
  dataCriacaoFinal: options.creationEndDate || '',
  dataEncerramentoInicial: options.closingInitialDate || '',
  dataEncerramentoFinal: options.closingEndDate || '',
  status: options.status,
  tipoOs: options.tipo,
  usuariosIds: options.users || '',
  servicosIds: options.servicos || '',
  clientesIds: options.clientes || '',
});
